
import {functions} from "@/scripts/firebase"
import { httpsCallable } from "firebase/functions"
import {startAfter,endAt,query,startAt,endBefore,orderBy,onSnapshot,Unsubscribe,QueryDocumentSnapshot, getDoc} from "firebase/firestore"
import { Component, Mixins, Watch  } from "vue-property-decorator"
import ModalEventDetails from "@/components/ModalUserEventDetails.vue"
import ModalAlert from "@/components/ModalAlert.vue";
import Common from '../../mixins/common';
import FullCalendar from '@fullcalendar/vue'
import {CalendarOptions, EventClickArg, DatesSetArg, EventInput} from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import luxon2Plugin from '@fullcalendar/luxon2'
import jaLocale from '@fullcalendar/core/locales/ja';
import {toHiragana,toZen} from 'jaconv'
import { EventData, EventExtendedProps, GetCalendarArg, GetCalendarRes } from "@/common-datatypes"
import TemplateMembers from "@/components/TemplateMembers.vue"
import { DateTime } from "luxon"

type Taxonomy = {
	[key in 'class' | 'group'|'type'|'status'|'postStatus']: Term[]
};

interface Term {
  name: string;
  id: string;
  count: number;
}

interface SelectedFilter {
  class: Term | null;
  group: Term | null;
  type: Term | null;
  status: Term | null;
  postStatus: Term | null;
  searchText: string;
}

@Component({
  components: {
    FullCalendar,
    ModalEventDetails,
    ModalAlert,
    TemplateMembers
  }
})

export default class Schedule extends Mixins(Common) {

  eventsObservers: Unsubscribe[] = []

  taxonomy: Taxonomy = {
    class: [],
    group: [],
    type: [],
    status: [],
    postStatus: [],
  }

  selectedFilter: SelectedFilter = {
    class: null,
    group: null,
    type: null,
    status: null,
    postStatus: null,
    searchText: '' 
  }
  
  showModalEventDetails = false
  showModalAlert = false

  alert = {title: '', message: ''}

  timeZone = ''
  
  defaultTheEventData: EventData = {
    id: '',
    title: '',
    timeZone: this.timeZone,
    start: DateTime.now().startOf('hour').toJSDate(),
    end: DateTime.now().startOf('hour').plus({hour: 1}).startOf('hour').toJSDate(),
    extendedProps: {
      note: '',
      type: 'lesson',
      className: '',
      classId: '',
      //classRef: undefined,
      teacherUserIds: [],
      studentUserIds: [],
      groupName: '',
      groupId: '',
      //groupRef: undefined,
      hostUserIds: [],
      guestUserIds: [],
      memberUserIds: [],
      memberMeta: {},
      status: 'pending',
      postStatus: 'draft',
      author: '',
      schoolId: this.$store.getters.schoolId,
      updateTime: undefined,
      creationTime: undefined
    }
  }

  theEventData = {...this.defaultTheEventData}

  modalEventProps = {
    isLoading: false,
    errorMessage: '',
    theEventData: this.theEventData
  }

  rawEvents: EventData[] = []
  currentEvents: EventData[] = []

  get calendarApi(){
    return (this.$refs.fullCalendar as InstanceType<typeof FullCalendar>).getApi()
  }

  iCalEvents = [] as EventInput[]

  calendarOptions: CalendarOptions = {
    plugins: [luxon2Plugin,dayGridPlugin,listPlugin ],// iCalendarPlugin,
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,listMonthCustom',
    },
    views: {
      listMonthCustom: {
        type: 'listMonth',
        duration: { days: 365},
        titleFormat: () => {
          return this.$t('schedule.list') as string
        }
      }
    },
    eventClassNames: (content) => {
      const classNames = []
      const exProps = content.event.extendedProps

      if(! exProps.docId){
        classNames.push('fc-event-imported')
      }

      if(exProps.status){
        classNames.push('fc-event-status-' + exProps.status)
      }
      if(exProps.postStatus){
        classNames.push('fc-event-poststatus-' + exProps.postStatus)
      }
      return classNames
    },
    aspectRatio: (() => {
      return window.innerWidth / window.innerHeight
    })(),
    windowResize: (arg) => {
      arg.view.calendar.setOption('aspectRatio', window.innerWidth / window.innerHeight)
    },
    windowResizeDelay: 300,
    dayMaxEvents: true,
    eventMaxStack: 3,
    firstDay: 1,//Monday
    navLinks: true,
    selectable: true,
    initialView: 'listMonthCustom',
    locales: [jaLocale],
    timeZone: undefined,
    locale: this.lang,
    eventClick: this.handleEventClick,
    eventTimeFormat: { hour12: false, hour: '2-digit', minute: '2-digit', timeZoneName: undefined },//timeZoneName: 'short'
    eventStartEditable: false,
    eventDurationEditable: false,
    datesSet: this.handleCalendarDatesSet,
    rerenderDelay: 0
  }

  Loading = false

  theEventDocId = ''

  Timer: number | undefined

  get offset(){
    const timeZone = this.$timeZoneList.find((tz) => {return tz.name === this.timeZone})
    return timeZone ? timeZone.offset : ''
  }

  setEvents(){
    this.calendarApi.batchRendering(() => {
      this.calendarApi.removeAllEvents()
      this.calendarApi.addEventSource(this.currentEvents)
      this.calendarApi.addEventSource(this.iCalEvents)
    })
  }

  @Watch('Loading')
  changeLoading(newval: boolean){
    console.log('change Loading')
    //console.log(newval)
    //console.log(this.rawEvents.length)
    if(newval === false){
      console.log('loaded')
      this.setTaxonomies()
      this.setFilterOnEventsData(this.selectedFilter)
      this.setEvents()
    }
  }

  get updatedRawEvents(){
    console.log('updatedRawEvents')
    const time = Date.now()
    if(this.currentEvents.length !== this.rawEvents.length){
      console.log('length')
      return time
    }
    
    if(this.rawEvents.some((rEvent) => {
        return this.currentEvents.some((cEvent) => {
          return rEvent.id && (cEvent.id === rEvent.id) && rEvent.extendedProps.updateTime !== cEvent.extendedProps.updateTime})
       })){
        console.log('update')
      return time
    }

    if(this.rawEvents.some((rEvent) => {
        return this.currentEvents.every((cEvent) => {return cEvent.id !== rEvent.id})
       })){
        console.log('delele')
      return time
    }
    return 0
  }
  @Watch('updatedRawEvents',{immediate: true})
  changeUpdateRawEvents(updated: number){
    console.log('update RawEvents')
    if(updated === 0){
      return
    }
    this.Loading = true
    const delay = 800
    window.clearTimeout(this.Timer)
    this.Timer = window.setTimeout(() => {
      this.Loading = false
    }, delay)
  }

  handleCalendarDatesSet(arg: DatesSetArg){
    console.log('change DatesSet')
    console.log(arg.view.type)
    const startDate = arg.view.activeStart
    const endDate = arg.view.activeEnd

    this.rawEvents = []
    this.setTaxonomies()
    this.$unsubscriber(this.eventsObservers)

    

    const setEventData = (doc: QueryDocumentSnapshot<EventData>) => {
      const event = doc.data()
      const findIndex = this.rawEvents.findIndex(rawEvent => {return event.id === rawEvent.id})
      event.timeZone = event.timeZone ? event.timeZone : this.timeZone
      if(findIndex === -1){
        this.rawEvents.push(event)
      }else{
        this.rawEvents.splice(findIndex, 1, event)
      }
    }

    try{
      const eventsStartQuery = query(this.$getUserEventsColRef(),orderBy('start','asc'),startAt(startDate),endBefore(endDate))

      const observerStart = onSnapshot(eventsStartQuery,(snapshot) => {
        //snapshot.docChanges
        snapshot.docs.forEach((doc) => {
          setEventData(doc)
        })
      })

      this.eventsObservers.push(observerStart)

      const eventsEndQuery = query(this.$getUserEventsColRef(),orderBy('end','asc'),startAfter(startDate),endAt(endDate))

      const observerEnd = onSnapshot(eventsEndQuery,(snapshot) => {
        snapshot.docs.forEach((doc) => {setEventData(doc)})
      })

      this.eventsObservers.push(observerEnd)

    }catch(error){
      console.log(error)
    }
    
  }

  setFilterOnEventsData(filter: SelectedFilter){
    const searchText = toHiragana(toZen(filter.searchText))

    const settingFilter = !! (filter.class || filter.group || filter.type || filter.status || filter.postStatus || filter.searchText)

    const foundSearchText = (val: string, event: EventData) => {
      if(val === ''){
          return false
      }

      const memberMeta = event.extendedProps.memberMeta || {}

      if(Object.values(memberMeta).some((user)=>{return this.$findTextByUserProfile(val,user)})){
        return true
      }

      let targetText = (event.title || '') + (event.note || '') + (event.description || '')

      targetText = toHiragana(toZen(targetText))

      if(targetText.indexOf(val) > -1){
          return true
      }
      return false
    }

    this.iCalEvents = this.iCalEvents.map(event => {
      const description = event.extendedProps?.description || ''
      const title = event.title || ''

      let targetText = title + description

      targetText = toHiragana(toZen(targetText))

      event.display = 'none'

      if(! settingFilter){
        event.display = 'auto'
        return event
      }

      if(searchText && targetText.indexOf(searchText) > -1){
        event.display = 'auto'
        return event
      }

      return event
     
    })

     this.currentEvents = this.rawEvents.map(event => {
      //const groupId = event.extendedProps.groupId
      const groupName = event.extendedProps.groupName || null
      //const classId = event.extendedProps.classId
      const className = event.extendedProps.className || null
      const type = event.extendedProps.type || null
      const status = event.extendedProps.status || null
      const postStatus = event.extendedProps.postStatus || null

      event.display = 'auto'

      if(! settingFilter){
        if(postStatus == 'trash'){
          event.display =  'none'
        }
        return event
      }

      if(searchText && ! foundSearchText(searchText, event)){
        event.display = 'none'
        return event
      }

      if(filter.type && filter.type.name && filter.type.name !== type){
        event.display = 'none'
        return event
      }

      if(filter.status && filter.status.name && filter.status.name !== status){
        event.display = 'none'
        return event
      }

      if(filter.postStatus && filter.postStatus.name && filter.postStatus.name !== postStatus){
        event.display = 'none'
        return event
      }

      if(filter.group && filter.group.name && filter.group.name !== groupName){
        event.display = 'none'
        return event
      }

      if(filter.class && filter.class.name && filter.class.name !== className){
        event.display = 'none'
        return event
      }

      return event
    })
  }

  @Watch('selectedFilter',{deep: true})
  changeSelectedFilter(newVal: SelectedFilter){
    this.setFilterOnEventsData(newVal)
    this.setEvents()
  }

  setTaxonomies(){
    this.resetCountTaxonomy()
  
    this.rawEvents.forEach(event => {
      const classId = event.extendedProps.classId
      const className = event.extendedProps.className
      const groupId = event.extendedProps.groupId
      const groupName = event.extendedProps.groupName
      const status = event.extendedProps.status
      const type = event.extendedProps.type
      const postStatus = event.extendedProps.postStatus
      
      if(groupId && groupName){
        this.setTaxonomy(this.taxonomy.group ,groupName, groupId)
      }

      if(classId && className){
        this.setTaxonomy(this.taxonomy.class ,className, classId)
      }

      if(type){
        this.setTaxonomy(this.taxonomy.type,type)
      }

      if(status){
        this.setTaxonomy(this.taxonomy.status,status)
      }

      if(postStatus){
        this.setTaxonomy(this.taxonomy.postStatus,postStatus)
      }
    })
  }

  resetCountTaxonomy(){
    Object.keys(this.taxonomy).forEach((type) => {
      const t = type as keyof Taxonomy
      this.taxonomy[t] = this.taxonomy[t].map((term) => {
        term.count = 0
        return term
      })
    })
  }

  setTaxonomy(type: Term[], name: string, id = ''){
    if(! name){
      return
    }

    const findIndex = type.findIndex((term) => {
      if(id !== ''){
        return term.id === id && term.name === name
      }
      return term.name === name
    })

    const term: Term = {
      name: name,
      count: 1,
      id: id
    }

    if(findIndex === -1){
      type.push(term)
    }else{
      term.count = 1 + type[findIndex].count
      type.splice(findIndex, 1,term)
    }
  }

  handleEventClick(arg: EventClickArg): void {
    if(arg.event.id && arg.jsEvent.ctrlKey === true && arg.view.type.indexOf('list') === -1){//selected
    /* まだ何もしない
      this.currentEvents = this.currentEvents.map((event) => {
        if(event.id === arg.event.id){
          event.borderColor = event.borderColor ? '' : '#000'
          event.groupId = event.groupId ? '' : 'selected'
          arg.view.calendar.batchRendering(() => {
            arg.event.remove()
            arg.view.calendar.addEvent(event)
          })
        }
        return event
      })
      */
    }

    this.theEventData.title = arg.event.title
    this.theEventData.timeZone = this.timeZone
    this.theEventData.start = arg.event.start || this.theEventData.start
    this.theEventData.end = arg.event.end || this.theEventData.end
    this.theEventData.extendedProps = arg.event.extendedProps as EventExtendedProps
    this.theEventData.id = arg.event.id
    this.showModalEventDetails = true
  }

  @Watch('timeZone')
  changeTimezone(newVal: string){
    console.log('change timeZone')
    this.calendarOptions.timeZone = newVal
    this.defaultTheEventData.timeZone = newVal
  }

  get lang(): string {
    return this.$store.getters.lang
  }

  @Watch('lang')
  changeLang(newVal: string){
    this.calendarOptions.locale = newVal
  }

  get queryEventDocId(){
    //docId == id
    return this.$route.query.eventId as string
  }

  @Watch('queryEventDocId',{immediate: true})
  async changeQueryEventId(eventDocId: string){
    console.log('query eventid')
       if(typeof eventDocId === 'string'){
        this.theEventDocId = eventDocId

        try{
          this.showModalEventDetails = false

          const eventDoc = await getDoc(this.$getEventDocRef(this.theEventDocId))

          if(eventDoc.exists()){
            const event = eventDoc.data()
            event.timeZone = event.timeZone ? event.timeZone : this.timeZone 

            if(event){

              this.theEventData = {
                ...this.theEventData,
                ...event,
              }
              this.modalEventProps = {
                ...this.modalEventProps,
                theEventData: this.theEventData
              }
              this.showModalEventDetails = true
            }
          }else{
            this.showModalAlert = true
            this.alert = {
              title: this.$t('message.notFound') as string,
              message: this.$t('event.notFound') as string
            }
          }
          this.theEventDocId = ''
        }catch(error){
          this.showModalAlert = true
          this.alert = {
            title: this.$t('message.notAuthorized') as string,
            message: this.$t('event.notAuthorized') as string
          }
        }
      }
  }


  async created(){
    console.trace('created')
    try{
      this.timeZone = this.$defaultTimeZone

      if(this.$store.state.userPrivateProfile.iCalendarUrl){
        const getCalendar = httpsCallable(functions,'getCalendar')
        const config: GetCalendarArg = {
          schoolId: this.$store.getters.schoolId,
          range: {
            start: DateTime.now().minus({year: 1}).toJSDate(),
            end: DateTime.now().plus({year: 1}).toJSDate()
          }
        }
        const jcalData = await getCalendar(config) as {data: GetCalendarRes}
        this.iCalEvents = jcalData.data
        this.calendarApi.addEventSource(this.iCalEvents)
      }
    }catch(error){
//
    }
  }

  mounted(){
    //
  }

  destroyed() {
    this.$unsubscriber(this.eventsObservers)
  }
}
